import useCountdown from "@hooks/useCountdown";
import { useTranslation } from "react-i18next";
// Import asset qua alias @assets (CRA/webpack bundle + hash). KHÔNG dùng
import weeklyBanner from "@assets/web-v3-images/home-el-weekly-action.png";

/**
 * Banner "Weekly Action" + ribbon đếm ngược. Chữ countdown overlay lên phần
 * ribbon vàng của ảnh banner — chỉnh `bottom` nếu vị trí ribbon trong ảnh đổi.
 */
const WeeklyActionBanner = ({ endsAt }) => {
  const { t } = useTranslation();
  const { label } = useCountdown(endsAt);

  return (
    <section
      style={{ backgroundImage: `url(${weeklyBanner})` }}
      className="@container bg-contain bg-no-repeat bg-center aspect-692/238 w-[90%] flex justify-center m-auto relative intro-tour-home"
    >
      <h2 className="absolute top-[37%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-max whitespace-nowrap text-[12cqw] font-extrabold leading-none">
        <span
          aria-hidden="true"
          className="absolute inset-0 px-[1.5cqw] pb-2 text-transparent bg-[#E8380D] bg-clip-text [-webkit-text-stroke:1.6cqw_transparent] [text-shadow:0_0.6cqw_0.8cqw_rgba(183,34,13,0.4)]"
        >
          {t("home.weekly.title")}
        </span>
        <span className="relative inline-block pb-2  px-[1.5cqw] text-transparent bg-linear-to-b from-[#FDFDBB] to-[#FCFCD9] bg-clip-text">
          {t("home.weekly.title")}
        </span>
      </h2>
      <p className="absolute bottom-[16%] md:bottom-[17%] left-1/2 -translate-x-1/2 whitespace-nowrap text-[3.8cqw] font-bold text-[#7a2e0e]">
        {t("home.weekly.endsIn", { time: label })}
      </p>
    </section>
  );
};

export default WeeklyActionBanner;
